import useTripStore from '../../context/TripStore';

const LocationInfoOverlay = () => {
  const { trip } = useTripStore();

  if (!trip.startLocation && !trip.endLocation) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-30 bg-white/95 backdrop-blur-sm border border-gray-200 rounded shadow-lg p-4 max-w-sm" style={{ pointerEvents: 'auto' }}>
      <div className="space-y-3">
        {trip.startLocation && (
          <div className="flex items-start gap-3">
            <div className="w-3 h-3 rounded-full bg-green-500 mt-1 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-xs font-light uppercase tracking-wide text-gray-500 mb-1">
                Start
              </div>
              <div className="text-sm font-light text-gray-800 truncate" title={trip.startLocation.name}>
                {trip.startLocation.name}
              </div>
              {trip.startLocation.address && (
                <div className="text-xs font-light text-gray-500 mt-1 truncate" title={trip.startLocation.address}>
                  {trip.startLocation.address}
                </div>
              )}
            </div>
          </div>
        )}
        
        {trip.endLocation && (
          <div className="flex items-start gap-3">
            <div className="w-3 h-3 rounded-full bg-red-500 mt-1 flex-shrink-0" />
            <div className="flex-1 min-w-0">
              <div className="text-xs font-light uppercase tracking-wide text-gray-500 mb-1">
                End
              </div>
              <div className="text-sm font-light text-gray-800 truncate" title={trip.endLocation.name}>
                {trip.endLocation.name}
              </div>
              {trip.endLocation.address && (
                <div className="text-xs font-light text-gray-500 mt-1 truncate" title={trip.endLocation.address}>
                  {trip.endLocation.address}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LocationInfoOverlay;



